import { Component, SimpleChange } from '@angular/core';

@Component({
    selector: 'app-default-body',
    templateUrl: './default-body.component.html',
    styleUrls: ['./default-body.component.scss'],
    standalone: false
})
export class DefaultBodyComponent {


}
